import { render } from "./session-map-page.vue?vue&type=template&id=6710b664"
import script from "./session-map-page.vue?vue&type=script&lang=js"
export * from "./session-map-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__